var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFront4({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 10,
    fill: "#FFE6C1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 22,
    width: 14,
    height: 14,
    rx: 7,
    fill: "#F9C579"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 29L29 31L33 27M22 25H18C16.1362 25 15.2044 25 14.4693 25.3045C13.4892 25.7105 12.7105 26.4892 12.3045 27.4693C12 28.2044 12 29.1362 12 31M25.5 13.2908C26.9659 13.8841 28 15.3213 28 17C28 18.6787 26.9659 20.1159 25.5 20.7092M23.5 17C23.5 19.2091 21.7091 21 19.5 21C17.2909 21 15.5 19.2091 15.5 17C15.5 14.7909 17.2909 13 19.5 13C21.7091 13 23.5 14.7909 23.5 17Z",
    stroke: "#A26A1A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFront4);
export default __webpack_public_path__ + "static/media/front-4.94a6fb16ddbd5d9e5b357b440ecca3fc.svg";
export { ForwardRef as ReactComponent };